import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "../../stores/zustand";

const RequirePaidAccess = () => {
  const { isAuthenticated, isPaid, isEmailVerified } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  const paymentPages = ["/checkout", "/checkout/success", "/payment-issue"];
  const isOnPaymentPage = paymentPages.some((page) =>
    location.pathname.startsWith(page)
  );

  if (!isPaid && !isOnPaymentPage && isEmailVerified) {
    return <Navigate to="/checkout" replace />;
  }

  return <Outlet />;
};

export default RequirePaidAccess;
